import {createGlobalStyle, css} from 'styled-components';

import type {ModalController} from './stores/ModalController/Modal.controller';

import {getColor, ms} from '../../styles';
import {CLOSE_TIMEOUT_MS} from './constants';

const sizingCss = css<{config: ModalController.Config}>`
  max-height: ${p => p.config.maxHeight};
  max-width: ${p => p.config.maxWidth};
  min-height: ${p => p.config.minHeight};
  min-width: ${p => p.config.minWidth};

  ${p =>
    p.config.isFullWidth &&
    css`
      width: 100%;
    `}
`;

export const ModalGlobalStyles = createGlobalStyle<{
  config: ModalController.Config;
  id: string;
}>`

    .ReactModalPortal {
        & .modal-overlay {
            align-items: center;
            background: #0000006b;
            display: flex;
            inset: 0;
            justify-content: center;
            opacity: 0;
            position: ${p => p.config.overlayPosition};
            transition: opacity ${CLOSE_TIMEOUT_MS}ms ease-in-out;
            z-index: ${p => p.config.overlayZIndex};
            ${p =>
              p.config.overlayBlur &&
              css`
                backdrop-filter: blur(
                  ${typeof p.config.overlayBlur === 'number'
                    ? p.config.overlayBlur
                    : 3}px
                );
              `}

            &.ReactModal__Overlay--after-open {
                opacity: 1;
            }

            &.ReactModal__Overlay--before-close {
                opacity: 0;
            }
        }

        & .modal-content {
            border-radius: ${ms(10)};
            display: flex;
            flex-direction: column;
            background: ${getColor('background.white')};
            margin: ${p => ms(p.config.modalOffset)};
            outline: none;
            overflow: hidden;
            transform: scale(0.95);
            transition: transform 200ms ease-in-out;

            &.ReactModal__Content--after-open {
                transform: scale(1);
            }

            &.ReactModal__Content--before-close {
                transform: scale(0.95);
            }

        }

        & .modal-content-${p => p.id} {
            ${sizingCss};
        }

    }

    .modal-no-scroll {
        overflow: hidden !important;
    }
`;
